import PropTypes from 'prop-types'
import React, { useState, useEffect, Fragment } from "react"
import { useSelector } from "react-redux"

import { connect } from "react-redux"
import { Form, Dropdown, DropdownMenu, DropdownItem, DropdownToggle, Input, Button } from "reactstrap"

import { Link } from "react-router-dom"

// Import menuDropdown
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import SettingBar from "../CommonForBoth/Settingbar"

// logo image
// import weaverLong from "../../assets/images/weaver_long.png";
import weaverLong from "../../assets/images/new_weaver_long.png";
import weaver from "../../assets/images/weaver.png";
// import weaverColor from "assets/images/weaver.png"

import { CLEAR_AUTH } from "../../store/auth/profile/actionTypes"
import { LOGOUT_USER } from "store/auth/login/actionTypes"
import { CLEAR_DATA } from "store/auth/data/actionTypes"
import store from "../../store"

const Header = props => {
  const selector = useSelector(state => state.Profile?.auth?.[0] || state.auth?.user || {})
  const [search, setsearch] = useState(false)
  const [singlebtn, setSinglebtn] = useState(false)
  const [mobileView, setMobileView] = useState(false)
  const [currentTime, setCurrentTime] = useState('')
  const [companyName, setCompanyName] = useState('')

  function tToggle() {
    var body = document.body;
    body.classList.toggle("sidebar-enable");
    if (window.screen.width > 992) {
      body.classList.toggle("vertical-collpsed");
    }
  }

  function formatKoreanDate() {
    const date = new Date()
    const days = ['일', '월', '화', '수', '목', '금', '토'];

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const weekday = days[date.getDay()];

    setCurrentTime(`${year}년 ${month}월 ${day}일 ${weekday}요일`)
  }

  async function handleLogout () {
    localStorage.removeItem('ACCESS_TOKEN')
    localStorage.removeItem('authUser');
    store.dispatch({type: CLEAR_AUTH})
    store.dispatch({type: LOGOUT_USER})
    store.dispatch({type: CLEAR_DATA})
    await persistor.purge()
  }

  function getCompanyName () {
    const companyData = selector?.member_group?.[0]?.company_group
    setCompanyName(companyData?.name || '')
  }

  useEffect(() => {
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if(viewportWidth <= 992 && !mobileView){
      setMobileView(true)
    }else{
      setMobileView(false)
    }
    const handleResize = () => {
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      if(viewportWidth <= 992 && !mobileView){
        setMobileView(true)
      }else{
        setMobileView(false)
      }
    };
    getCompanyName()
    formatKoreanDate()

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center">

            {!mobileView && 
              <div className="navbar-brand-box logo-container">
                <Link to="/dashboard" className="logo">
                  <span className="logo-lg">
                    <img src={weaverLong} alt="" height="16" />
                  </span>
                </Link>
                <Link to="/dashboard" className="logo">
                  <span className="logo-sm">
                    <img src={weaver} alt="" height="22" />
                  </span>
                </Link>
              </div>
            }

            {/* {mobileView &&  */}
            <button type="button" className="btn btn-sm px-3 font-size-24 header-item waves-effect"
              id="vertical-menu-btn"
              onClick={() => {
                tToggle()
              }}
              data-target="#topnav-menu-content"
            >
              <i className="mdi mdi-menu"></i>
            </button>
            {/* } */}

            {!mobileView &&
              <p className='margin-bottom-0 font-size-18'>{companyName}</p>
            }

            {mobileView && 
            <div style={{width: 64}}></div>
            }

            <div className="d-none d-sm-block">

              <Dropdown
                isOpen={singlebtn}
                toggle={() => setSinglebtn(!singlebtn)}
                className="pt-3 d-inline-block"
              >
                {/* <DropdownToggle className="btn btn-secondary" caret>
                  Create <i className="mdi mdi-chevron-down"></i>
                </DropdownToggle> */}
                <DropdownMenu>
                  <DropdownItem>Action</DropdownItem>
                  <DropdownItem>Another action</DropdownItem>
                  <DropdownItem>Something else here</DropdownItem>
                  <div className="dropdown-divider"></div>
                  <DropdownItem>Separated link</DropdownItem>
                </DropdownMenu>
              </Dropdown>

            </div>
          </div>

          {mobileView && 
          <div className='d-flex'>
            <Link to="/dashboard" className="logo logo-light">
              <span className="logo-sm">
                <img src={weaver} alt="" height="32" />
              </span>
            </Link>
          </div>
          }

          <div className="d-flex align-items-center">
            {/* <form className="app-search d-none d-lg-block">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder={props.t("검색어를 입력해주세요") + "..."}
                />
                <span className="fa fa-search"></span>
              </div>
            </form> */}

            <Dropdown
              className="d-inline-block d-lg-none ms-2"
              onClick={() => {
                setsearch(!search)
              }}
              type="button"
            >
              {/* <DropdownToggle
                className="btn header-item noti-icon waves-effect"
                id="page-header-search-dropdown"
                tag="button"
              > <i className="mdi mdi-magnify"></i>
              </DropdownToggle> */}
              <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                <Form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <Input type="text" className="form-control" placeholder="Search ..." aria-label="Recipient's username" />
                      <div className="input-group-append">
                        <Button className="btn btn-primary" type="submit"><i className="mdi mdi-magnify"></i></Button>
                      </div>
                    </div>
                  </div>
                </Form>
              </DropdownMenu>
            </Dropdown>

            {!mobileView &&
            <Fragment>
              <p className='margin-bottom-0 font-size-18 margin-right-24'>{currentTime}</p>

              <button style={{width: 141}} type="button" className="custom-btn btn-dark-gradient border-radius-0 white-text border-none"
                id="vertical-menu-btn"
                onClick={(e) => {
                  e.preventDefault()
                  handleLogout()
                }}
                data-target="#topnav-menu-content"
              >
                로그아웃
              </button>
            </Fragment>
            }

            {/* <div className="dropdown d-none d-lg-inline-block">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen()
                }}
                className="btn header-item noti-icon waves-effect"
                data-toggle="fullscreen"
              >
                <i className="mdi mdi-fullscreen"></i>
              </button>
            </div> */}

            <NotificationDropdown />

            {/* <div
              onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar)
              }}
              className="dropdown d-inline-block"
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle waves-effect"
              >
                <i className="mdi mdi-cog-outline"></i>
              </button>
            </div> */}
            <SettingBar />
            {/* <div
              onClick={() => {
                props.showSettingbarAction(!props.showSettingbar)
              }}
              className="dropdown d-inline-block"
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle waves-effect"
              >
                <i className="mdi mdi-cog-outline"></i>
              </button>
            </div> */}
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

export default Header
